/* FILLE - tema Shopify -------------------------------------------------- */
(function () {
  'use strict';

  /* ---------- menu mobile ---------- */
  var burger  = document.querySelector('.hamburger');
  var drawer  = document.getElementById('drawer');
  var backdrop= document.getElementById('drawerBackdrop');
  function abreDrawer(v) {
    if (!drawer) return;
    drawer.classList.toggle('open', v);
    if (backdrop) backdrop.classList.toggle('open', v);
    document.body.style.overflow = v ? 'hidden' : '';
  }
  if (burger)   burger.addEventListener('click', function () { abreDrawer(true); });
  if (backdrop) backdrop.addEventListener('click', function () { abreDrawer(false); });
  var fechar = document.querySelector('.drawer-close');
  if (fechar) fechar.addEventListener('click', function () { abreDrawer(false); });

  /* ---------- mega menu ---------- */
  var trigger = document.querySelector('.nav-mega-trigger');
  var mega    = document.querySelector('.mega-menu');
  if (trigger && mega) {
    var fora;
    function abreMega(v) {
      mega.classList.toggle('open', v);
      clearTimeout(fora);
    }
    trigger.addEventListener('click', function (e) { e.preventDefault(); abreMega(!mega.classList.contains('open')); });
    trigger.addEventListener('mouseenter', function () { abreMega(true); });
    mega.addEventListener('mouseenter', function () { clearTimeout(fora); });
    [trigger, mega].forEach(function (el) {
      el.addEventListener('mouseleave', function () { fora = setTimeout(function () { abreMega(false); }, 220); });
    });
    document.addEventListener('click', function (e) {
      if (!mega.contains(e.target) && e.target !== trigger) abreMega(false);
    });

  }

  /* ---------- o que vem da fille.global: WhatsApp, categorias e banner do menu ---------- */
  (function () {
    var FONTE = 'https://fille.global/menu-shopify.php';
    function limpa(v) {
      var d = document.createElement('div');
      d.textContent = v == null ? '' : String(v);
      return d.innerHTML;
    }
    fetch(FONTE, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j) return;

        /* WhatsApp: link e numero saem da configuracao do Thix */
        var w = j.wpp;
        if (w && w.link) {
          var topo = document.querySelector('.header-contact');
          if (topo) {
            topo.setAttribute('href', w.link);
            topo.setAttribute('target', '_blank');
            topo.setAttribute('rel', 'noopener');
            if (w.texto) {
              var no = topo.lastChild;
              if (no && no.nodeType === 3) { no.nodeValue = ' ' + w.texto; }
            }
          }
          var flutua = document.querySelector('.whatsapp-float');
          if (flutua) { flutua.setAttribute('href', w.link); }
        }

        var mega = document.querySelector('.mega-menu');
        if (!mega) return;

        var lista = mega.querySelector('[data-col="1"]');
        if (lista && j.categorias && j.categorias.length) {
          var html = j.categorias.map(function (c) {
            return '<a href="' + limpa(c.link) + '">' + limpa(c.titulo) + '</a>';
          }).join('');
          var verTudo = lista.querySelector('a[href$="/collections/all"]');
          lista.innerHTML = html + '<a href="/collections/all">' + (verTudo ? limpa(verTudo.textContent) : 'View All') + '</a>';
        }

        var faixa = document.getElementById('megaBanner');
        var b = j.banner;
        if (faixa && b && b.foto) {
          var img = faixa.querySelector('img');
          if (img) img.src = b.foto;
          if (b.link) faixa.setAttribute('href', b.link);
          var ey = faixa.querySelector('.eyebrow');
          var ti = faixa.querySelector('h5');
          var bt = faixa.querySelector('[data-btn="descobrir"]');
          if (ey) { ey.textContent = b.eyebrow || ''; ey.hidden = !b.eyebrow; }
          if (ti) { ti.innerHTML = limpa(b.titulo || '').replace(/\r?\n/g, '<br>'); ti.hidden = !b.titulo; }
          if (bt) { bt.textContent = b.botao || ''; bt.hidden = !b.botao; }
        }
      })
      .catch(function () { /* fica o que o tema ja trazia */ });
  })();

  /* ---------- carrossel de categorias ---------- */
  document.querySelectorAll('.cat-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.cat-track');
    if (!track) return;
    function passo() {
      var it = track.querySelector('.cat-item');
      return it ? it.getBoundingClientRect().width : 350;
    }
    var p = wrap.querySelector('.cat-arrow.prev');
    var n = wrap.querySelector('.cat-arrow.next');
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left:  passo(), behavior: 'smooth' }); });
  });

  /* ---------- categorias vindas do fille.global (fotos do Thix) ---------- */
  (function () {
    var track = document.getElementById('catTrack');
    if (!track) return;
    var fonte = track.getAttribute('data-fonte') || '';
    if (!fonte) return;
    function limpa(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }
    fetch(fonte, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var lista = j && j.categorias;
        if (!lista || !lista.length) return;
        track.innerHTML = lista.map(function (c) {
          return '<a class="cat-item" data-cat-item href="' + limpa(c.link) + '">'
               +   '<div class="cat-img-wrap"><img src="' + limpa(c.foto) + '" alt="' + limpa(c.titulo) + '" loading="lazy"></div>'
               +   '<div class="cat-pill">' + limpa(c.titulo) + '</div>'
               + '</a>';
        }).join('');
      })
      .catch(function () { /* fica o que o tema ja trazia */ });
  })();

  /* ---------- hero vindo do fille.global ---------- */
  var hero = document.getElementById('hero');
  if (hero) {
    var fonte = hero.getAttribute('data-fonte');
    var stage = hero.querySelector('.hero-stage');
    var dots  = hero.querySelector('.hero-dots');

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function quebra(s) { return esc(s).replace(/\r?\n/g, '<br>'); }

    function monta(lista) {
      if (!lista || !lista.length) return;
      stage.innerHTML = '';
      if (dots) dots.innerHTML = '';

      lista.forEach(function (b, i) {
        var e = b.estilo || {};
        /* mesma regra do fille.global: so o literal left/center muda o lado */
        var alinhar = b.alinhar === 'left' ? 'left' : (b.alinhar === 'center' ? 'center' : 'right');
        var overlay = alinhar === 'left' ? 'fhero-overlay-l' : 'fhero-overlay-r';

        var slide = document.createElement('div');
        slide.className = 'fhero-slide' + (i === 0 ? ' active' : '');
        slide.style.backgroundImage = 'url(' + b.imagem + ')';

        var html = '<div class="' + overlay + '"></div>'
                 + '<div class="fhero-text ' + alinhar + '">';
        if (b.chamada) {
          html += '<p class="eyebrow" style="font-family:\'' + esc(e.chamada_fonte || 'Montserrat') + '\',sans-serif;'
               +  'color:' + esc(e.chamada_cor || '#fff') + ';font-size:' + esc(e.chamada_tamanho || '14px') + '">'
               +  esc(b.chamada) + '</p>';
        }
        if (b.titulo) {
          html += '<h2 style="font-family:\'' + esc(e.titulo_fonte || 'Cormorant Garamond') + '\',serif;'
               +  'color:' + esc(e.titulo_cor || '#fff') + ';font-size:' + esc(e.titulo_tamanho || '88px') + '">'
               +  quebra(b.titulo) + '</h2>';
        }
        if (b.texto) {
          html += '<p class="desc" style="font-family:\'' + esc(e.texto_fonte || 'Cormorant Garamond') + '\',serif;'
               +  'color:' + esc(e.texto_cor || 'rgba(255,255,255,.85)') + ';font-size:' + esc(e.texto_tamanho || '18px') + '">'
               +  quebra(b.texto) + '</p>';
        }
        if (b.botao) {
          html += '<a class="btn" href="' + esc(b.link || '/collections/all') + '"'
               +  ' style="font-size:' + esc(e.botao_tamanho || '14px') + '">' + esc(b.botao) + '</a>';
        }
        html += '</div>';
        slide.innerHTML = html;
        stage.appendChild(slide);

        if (dots && lista.length > 1) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = i === 0 ? 'active' : '';
          d.setAttribute('aria-label', 'Slide ' + (i + 1));
          d.addEventListener('click', function () { vai(i); });
          dots.appendChild(d);
        }
      });

      var atual = 0;
      var slides = stage.querySelectorAll('.fhero-slide');
      var bolas  = dots ? dots.querySelectorAll('button') : [];

      function vai(i) {
        atual = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('active', k === atual); });
        bolas.forEach && bolas.forEach(function (b, k) { b.classList.toggle('active', k === atual); });
      }
      hero.querySelectorAll('.hero-arrow').forEach(function (a) {
        a.addEventListener('click', function () { vai(atual + (a.classList.contains('next') ? 1 : -1)); });
      });
      if (slides.length > 1) setInterval(function () { vai(atual + 1); }, 6500);
    }

    if (fonte) {
      fetch(fonte, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (j) { monta(j && j.banners); })
        .catch(function () { /* fica o banner de reserva do tema */ });
    }
  }

  /* ---------- Fille TV: bolinhas e visor ---------- */
  var row = document.getElementById('storiesRow');
  if (row && row.getAttribute('data-fonte')) {
    var visor  = document.getElementById('storyViewer');
    var vid    = document.getElementById('svVideo');
    var barra  = document.getElementById('svBarra');
    var nome   = document.getElementById('svNome');
    var preco  = document.getElementById('svPreco');
    var parc   = document.getElementById('svParcela');
    var btn    = document.getElementById('svBtn');
    var som    = document.getElementById('svSom');
    var lista  = [];
    var atual  = 0;
    var timer  = null;

    function abre(i) {
      if (!lista.length) return;
      atual = (i + lista.length) % lista.length;
      var s = lista[atual];
      vid.src = s.video;
      vid.currentTime = 0;
      vid.play().catch(function () {});
      nome.textContent  = s.nome || '';
      preco.textContent = s.preco || '';
      parc.textContent  = s.parcela || '';
      btn.href = s.link || '#';
      visor.classList.add('open');
      document.body.style.overflow = 'hidden';
      anda();
    }
    function anda() {
      clearInterval(timer);
      var t0 = Date.now();
      timer = setInterval(function () {
        var dur = (vid.duration && isFinite(vid.duration)) ? vid.duration * 1000 : 8000;
        var p = Math.min(100, ((Date.now() - t0) / dur) * 100);
        barra.style.width = p + '%';
        if (p >= 100) { abre(atual + 1); }
      }, 60);
    }
    function fecha() {
      visor.classList.remove('open');
      clearInterval(timer);
      vid.pause();
      vid.removeAttribute('src');
      document.body.style.overflow = '';
    }

    visor.querySelectorAll('[data-sv-fechar]').forEach(function (b) { b.addEventListener('click', fecha); });
    document.getElementById('svAnt').addEventListener('click', function () { abre(atual - 1); });
    document.getElementById('svProx').addEventListener('click', function () { abre(atual + 1); });
    som.addEventListener('click', function () {
      vid.muted = !vid.muted;
      som.innerHTML = vid.muted ? '&#128264;' : '&#128266;';
    });
    document.addEventListener('keydown', function (e) {
      if (!visor.classList.contains('open')) return;
      if (e.key === 'Escape') fecha();
      if (e.key === 'ArrowRight') abre(atual + 1);
      if (e.key === 'ArrowLeft') abre(atual - 1);
    });

    fetch(row.getAttribute('data-fonte'), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        lista = (j && j.stories) || [];
        row.innerHTML = '';
        lista.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'story-bubble';
          b.innerHTML = '<span class="story-ring"><img src="' + (s.capa || '') + '" alt="" loading="lazy"></span>'
                      + '<span class="story-nome"></span>';
          b.querySelector('.story-nome').textContent = s.nome || '';
          b.addEventListener('click', function () { abre(i); });
          row.appendChild(b);
        });
      })
      .catch(function () {});
  }

  /* ---------- newsletter ---------- */
  var nl = document.querySelector('.newsletter-form');
  if (nl) {
    nl.addEventListener('submit', function () {
      var ok = nl.parentNode.querySelector('.newsletter-ok');
      if (ok) ok.textContent = '';
    });
  }
})();
